/// <amd-module name="Repos/VersionDialogs/Dialogs" />
export { CreateBranchDialog } from "./Components/Create/CreateBranchDialog";
export { CreateTagDialog } from "./Components/Create/CreateTagDialog";
export { DeleteBranchDialog } from "./Components/Delete/DeleteBranchDialog";
export { DeleteTagDialog } from "./Components/Delete/DeleteTagDialog";
export { createBranch, createTag, deleteBranch, deleteTag } from "./VersionDialogActionsService";
